"use strict";
/*
A `pass` is just a function that is executed on `req, res, options`
so that you can easily add new checks while still keeping the base
flexible.

The names of passes are exported as WEB_PASSES from this module.

*/
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.WEB_PASSES = void 0;
exports.deleteLength = deleteLength;
exports.timeout = timeout;
exports.XHeaders = XHeaders;
exports.stream = stream;
const http = __importStar(require("node:http"));
const https = __importStar(require("node:https"));
const web_outgoing_1 = require("./web-outgoing");
const common = __importStar(require("../common"));
const followRedirects = __importStar(require("follow-redirects"));
const web_o = Object.values(web_outgoing_1.OUTGOING_PASSES);
const nativeAgents = { http, https };
//  Sets `content-length` to '0' if request is of DELETE type.
function deleteLength(req) {
    if ((req.method === "DELETE" || req.method === "OPTIONS") &&
        !req.headers["content-length"]) {
        req.headers["content-length"] = "0";
        delete req.headers["transfer-encoding"];
    }
}
// Sets timeout in request socket if it was specified in options.
function timeout(req, _res, options) {
    if (options.timeout) {
        req.socket.setTimeout(options.timeout);
    }
}
// Sets `x-forwarded-*` headers if specified in config.
function XHeaders(req, _res, options) {
    if (!options.xfwd) {
        return;
    }
    const encrypted = common.hasEncryptedConnection(req);
    const values = {
        for: req.connection.remoteAddress || req.socket.remoteAddress,
        port: common.getPort(req),
        proto: encrypted ? "https" : "http",
    };
    for (const header of ["for", "port", "proto"]) {
        req.headers["x-forwarded-" + header] =
            (req.headers["x-forwarded-" + header] || "") +
                (req.headers["x-forwarded-" + header] ? "," : "") +
                values[header];
    }
    req.headers["x-forwarded-host"] =
        req.headers["x-forwarded-host"] || req.headers["host"] || "";
}
// Does the actual proxying. If `forward` is enabled fires up
// a ForwardStream (there is NO RESPONSE), same happens for ProxyStream. The request
// just dies otherwise.
function stream(req, res, options, _, server, cb) {
    // And we begin!
    server.emit("start", req, res, options.target || options.forward);
    const agents = options.followRedirects ? followRedirects : nativeAgents;
    const http = agents.http;
    const https = agents.https;
    if (options.forward) {
        // forward enabled, so just pipe the request
        const proto = options.forward.protocol === "https:" ? https : http;
        const outgoingOptions = common.setupOutgoing(options.ssl || {}, options, req, "forward");
        const forwardReq = proto.request(outgoingOptions);
        // error handler (e.g. ECONNRESET, ECONNREFUSED)
        // Handle errors on incoming request as well as it makes sense to
        const forwardError = createErrorHandler(forwardReq, options.forward);
        req.on("error", forwardError);
        forwardReq.on("error", forwardError);
        (options.buffer || req).pipe(forwardReq);
        if (!options.target) {
            // no target, so we do not send anything back to the client.
            // If target is set, we do a separate proxy below, which might be to a
            // completely different server.
            return res.end();
        }
    }
    // Request initalization
    const proto = options.target.protocol === "https:" ? https : http;
    const outgoingOptions = common.setupOutgoing(options.ssl || {}, options, req);
    const proxyReq = proto.request(outgoingOptions);
    // Enable developers to modify the proxyReq before headers are sent
    proxyReq.on("socket", (socket) => {
        if (server && !proxyReq.getHeader("expect")) {
            server.emit("proxyReq", proxyReq, req, res, options, socket);
        }
    });
    // allow outgoing socket to timeout so that we could
    // show an error page at the initial request
    if (options.proxyTimeout) {
        proxyReq.setTimeout(options.proxyTimeout, () => {
            proxyReq.destroy();
        });
    }
    // Ensure we abort proxy if request is aborted
    res.on("close", () => {
        const aborted = !res.writableFinished;
        if (aborted) {
            proxyReq.destroy();
        }
    });
    // handle errors in proxy and incoming request, just like for forward proxy
    const proxyError = createErrorHandler(proxyReq, options.target);
    req.on("error", proxyError);
    proxyReq.on("error", proxyError);
    function createErrorHandler(proxyReq, url) {
        return (err) => {
            if (req.socket.destroyed && err.code === "ECONNRESET") {
                server.emit("econnreset", err, req, res, url);
                proxyReq.destroy();
                return;
            }
            if (cb) {
                cb(err, req, res, url);
            }
            else {
                server.emit("error", err, req, res, url);
            }
        };
    }
    (options.buffer || req).pipe(proxyReq);
    proxyReq.on("response", (proxyRes) => {
        server?.emit("proxyRes", proxyRes, req, res);
        if (!res.headersSent && !options.selfHandleResponse) {
            for (const pass of web_o) {
                // note: none of these return anything
                pass(req, res, proxyRes, options);
            }
        }
        if (!res.finished) {
            // Allow us to listen for when the proxy has completed
            proxyRes.on("end", () => {
                server?.emit("end", req, res, proxyRes);
            });
            // We pipe to the response unless its expected to be handled by the user
            if (!options.selfHandleResponse) {
                proxyRes.pipe(res);
            }
        }
        else {
            server?.emit("end", req, res, proxyRes);
        }
    });
}
exports.WEB_PASSES = { deleteLength, timeout, XHeaders, stream };
